(function () {
    'use strict';

    angular
        .module('app.campaignActivity')
        .controller('campaignActivityDeleteCtrl', ['$scope', '$rootScope', '$modal', '$modalInstance', '$state', 'campaignActivityService',
            function ($scope, $rootScope, $modal, $modalInstance, $state, campaignActivityService) {

                $scope.confirmDelete = function () {
                    campaignActivityService.deleteInfluencerFromCampaign($scope.paramsFromParent.campaignInfluencerId, true)
                        .then(function (response) {
                            $scope.closeModal();
                            window.location.href = $rootScope.previousPageOfActivityPage;
                        }, function (response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.closeModal = function () {
                    $modalInstance.close();
                }
            }
        ]);
})();